require('./bootstrap');

import Vue from 'vue';

// FIXME: this is only temporal
/* try {
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
} catch (e) {} */

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import store from './store';

// import axios from 'axios';
import Bang from './Bang';

/* const TOKEN = document.head.querySelector('meta[name="csrf-token"]').content;

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-CSRF-TOKEN'] = TOKEN;
*/

import VueSweetalert2 from "vue-sweetalert2";

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";
import Vuelidate from 'vuelidate'
import mixins from './mixins/methods.js';

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueSweetalert2);
Vue.use(Vuelidate);
Vue.mixin(mixins);

Vue.use({
  install(Vue, options) {
    const errorsBang = { get: () => new Bang(server_props.errors || {}) };
    const oldsBang = { get: () => new Bang(server_props.old || {}) };

    Object.defineProperty(Vue.prototype, '$errors', errorsBang);
    Object.defineProperty(Vue.prototype, '$oldInputs', oldsBang);
  }
});

Vue.component('csrf-field', {
  template: `<input type="hidden" name="_token" value="${_csrf_token}"/>`
});
Vue.component('login', require('./pages/Login.vue').default);
Vue.component('employees', require('./pages/Employees.vue').default);
Vue.component('organization-chart', require('./pages/OrganizationChart.vue').default);
Vue.component('payroll', require('./pages/Payroll.vue').default);
Vue.component('users', require('./pages/Users.vue').default);

new Vue({
  store: store,
  props: {
    
  },
  mounted() {
    console.log(this);
  },
  computed: {
    serverProps() {
      if (typeof server_props !== 'undefined') {
        return '';
      }

      return '';
    }
  },
}).$mount('#app');
